export default "__VITE_ASSET__DKkAQy9G__"